'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-f8b34207.js');
require('whatwg-fetch');
var secondLocation = require('../secondLocation.js');
var thirdLocation = require('../thirdLocation.js');
var getUrlCacheIndex = require('../getUrlCacheIndex.js');
var isNumber = require('lodash/isNumber');
var localCache = require('../localCache.js');
var errors_formatError = require('../errors/formatError.js');
var makeHash = require('../makeHash.js');
var localStore = require('../localStore.js');
var logger_index = require('../logger/index.js');
require('lodash/shuffle');
require('../memoryStorage.js');
require('../_storageService-fcdc54f2.js');
require('../eventEmitter.js');
require('../configService.js');
require('../errors/errorCodes.js');
require('../errors/appError.js');
require('../makeId.js');
require('../logger/helpers.js');
require('../deepMerge.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var isNumber__default = /*#__PURE__*/_interopDefaultLegacy(isNumber);

var FetchAMS = /** @class */ (function () {
    function FetchAMS() {
        var _this = this;
        this.$logger = new logger_index.StyledLogger('FetchAMS', {
            debug: {
                active: true,
                level: logger_index.StyledLogger.TRACE_LEVEL
            }
        });
        this.errorsQueue = {
            _queue: [],
            activeTask: null,
            handleAll: true,
            push: function (task, isHandle) {
                var _a, _b;
                if (isHandle === void 0) { isHandle = true; }
                if (((_a = _this.errorsQueue.activeTask) === null || _a === void 0 ? void 0 : _a.id) !== task.id) {
                    _this.errorsQueue._queue.push(task);
                }
                if (isHandle) {
                    if (((_b = _this.errorsQueue.activeTask) === null || _b === void 0 ? void 0 : _b.id) === task.id) {
                        _this.handleQueue(_this.errorsQueue.activeTask);
                    }
                    else if (!_this.errorsQueue.activeTask) {
                        var nextTask = _this.errorsQueue.getNextTask();
                        if (nextTask) {
                            _this.handleQueue(nextTask);
                        }
                    }
                }
            },
            getNextTask: function () {
                var index = _this.errorsQueue.handleAll ? 0 : _this.errorsQueue._queue.findIndex(function (t) { return t.actionStatus !== 'freeze'; });
                if (index !== -1 && _this.errorsQueue._queue[index]) {
                    var nextTask = _this.errorsQueue._queue.splice(index, 1)[0];
                    return nextTask;
                }
                return null;
            }
        };
    }
    Object.defineProperty(FetchAMS.prototype, "connectionStatus", {
        get: function () {
            return localStore.localStore.get('connectionStatus') || 'stable';
        },
        set: function (val) {
            localStore.localStore.set('connectionStatus', val);
            // this._connectionStatus = val;
        },
        enumerable: false,
        configurable: true
    });
    FetchAMS.prototype.get = function (url, options) {
        if (options === void 0) { options = {}; }
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                options.method = 'get';
                return [2 /*return*/, this.request(url, options)];
            });
        });
    };
    FetchAMS.prototype.post = function (url, body, options) {
        options.body = body;
        options.method = 'post';
        return this.request(url, options);
    };
    FetchAMS.prototype.put = function (url, body, options) {
        options.body = body;
        options.method = 'put';
        return this.request(url, options);
    };
    FetchAMS.prototype.request = function (url, options) {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var isExpiredRecord, cacheIndex, notExpiredCacheRow, useCache, hasQuery, key;
            var _this = this;
            return tslib_es6.__generator(this, function (_a) {
                isExpiredRecord = false;
                useCache = !!((options === null || options === void 0 ? void 0 : options.useCache) && (options === null || options === void 0 ? void 0 : options.method) === 'get');
                hasQuery = url.toString().indexOf('?') !== -1;
                if ((options === null || options === void 0 ? void 0 : options.query) && typeof options.query === 'object') {
                    for (key in options.query) {
                        if (url instanceof URL) {
                            url.searchParams.set(key, options.query[key]);
                        }
                        else {
                            url += "".concat(hasQuery ? '&' : '?').concat(encodeURIComponent(key), "=").concat(encodeURIComponent(options.query[key]));
                        }
                        hasQuery = true;
                    }
                }
                if (options && useCache) { // it need for 2nd location
                    cacheIndex = getUrlCacheIndex.getUrlCacheIndex(url);
                    notExpiredCacheRow = localCache.localCache.get(cacheIndex, false); // returns something only if not expired
                    if (notExpiredCacheRow) {
                        notExpiredCacheRow.cached = true;
                        notExpiredCacheRow.ams_url = url.toString();
                        return [2 /*return*/, notExpiredCacheRow];
                    }
                    isExpiredRecord = !!localCache.localCache.get(cacheIndex, false, true);
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.call(url.toString(), options, function (err, res) {
                            var _a;
                            if (!err) {
                                var checkBeforeCache = typeof options.useCache === 'function' ? options.useCache(res) : true;
                                // if came back expired record from cache or from new request
                                if (useCache && (!res.cached || isExpiredRecord) && checkBeforeCache) {
                                    delete res.cached;
                                    localCache.localCache.set(cacheIndex, res, ((_a = res === null || res === void 0 ? void 0 : res.op) === null || _a === void 0 ? void 0 : _a.cache_time) || null);
                                }
                                resolve(res);
                            }
                            else {
                                if (useCache) {
                                    localCache.localCache.delIfExpire(cacheIndex);
                                }
                                reject(err);
                            }
                        }, cacheIndex, isExpiredRecord);
                    })];
            });
        });
    };
    FetchAMS.prototype.call = function (url, options, callback, cacheIndex, cacheState, id) {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            return tslib_es6.__generator(this, function (_a) {
                fetch(url, options)
                    .then(function (res) { return tslib_es6.__awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return tslib_es6.__generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                response = res;
                                if (!!response.ok) return [3 /*break*/, 7];
                                if (!((response === null || response === void 0 ? void 0 : response.status) && (response === null || response === void 0 ? void 0 : response.status) < 500)) return [3 /*break*/, 6];
                                _a = (options === null || options === void 0 ? void 0 : options.type) || 'json';
                                switch (_a) {
                                    case 'json': return [3 /*break*/, 1];
                                    case 'text': return [3 /*break*/, 3];
                                }
                                return [3 /*break*/, 3];
                            case 1: return [4 /*yield*/, response.json()];
                            case 2: throw (_b.sent());
                            case 3: return [4 /*yield*/, response.text()];
                            case 4: throw (_b.sent());
                            case 5: return [3 /*break*/, 7];
                            case 6: throw new Error("[".concat(response.status, "] ").concat(response.statusText));
                            case 7:
                                switch ((options === null || options === void 0 ? void 0 : options.type) || 'json') {
                                    case 'arrayBuffer':
                                        return [2 /*return*/, response.arrayBuffer()];
                                    case 'blob':
                                        return [2 /*return*/, response.blob()];
                                    case 'formData':
                                        return [2 /*return*/, response.formData()];
                                    case 'json':
                                        return [2 /*return*/, response.json()];
                                    case 'text':
                                    default:
                                        return [2 /*return*/, response.text()];
                                }
                                return [2 /*return*/];
                        }
                    });
                }); })
                    // .then((respJson) => {
                    //   if (!response.ok) {
                    //     throw respJson;
                    //   } else {
                    //     return respJson;
                    //   }
                    // })
                    .then(function (respJson) {
                    var _a;
                    // thirdLocation.emitupdateShowLoader(false);
                    _this.connectionStatus = 'stable';
                    if ((!options.type || options.type === 'json') && (respJson === null || respJson === void 0 ? void 0 : respJson.error)) { // AMS error like not 401 etc - don't need to handle by 2nd location logic
                        callback(errors_formatError.formatError(respJson, true, response || {}), null);
                    }
                    else {
                        callback(null, respJson || {});
                    }
                    if (_this.errorsQueue.activeTask && ((_a = _this.errorsQueue.activeTask) === null || _a === void 0 ? void 0 : _a.id) === id) {
                        _this.errorsQueue.activeTask = null;
                    }
                    var nextTask;
                    if (!_this.errorsQueue.activeTask && _this.errorsQueue._queue.length) {
                        nextTask = _this.errorsQueue.getNextTask();
                        if (nextTask) {
                            _this.handleQueue(nextTask);
                        }
                    }
                    if (!_this.errorsQueue.activeTask && !nextTask) {
                        if (thirdLocation.thirdLocation.isEnabled()) {
                            thirdLocation.thirdLocation.connectionStatus(_this.connectionStatus, { url: url, httpCode: response === null || response === void 0 ? void 0 : response.status });
                        }
                    }
                })
                    .catch(function (error) {
                    if ([403, 404, 402].indexOf(response === null || response === void 0 ? void 0 : response.status) !== -1) { // if AMS return 404
                        throw Error;
                    }
                    _this.connectionStatus = 'unstable';
                    if (secondLocation.secondLocation.isEnabled()) {
                        _this.errorsQueue.push({
                            id: id || makeHash.makeHash(10),
                            status: response === null || response === void 0 ? void 0 : response.status,
                            url: url,
                            options: options,
                            callback: callback,
                            error: error,
                            response: response,
                            cacheState: cacheState,
                            cacheIndex: cacheIndex
                        });
                    }
                    else if (thirdLocation.thirdLocation.isEnabled()) {
                        thirdLocation.thirdLocation.connectionStatus(_this.connectionStatus, { url: url, httpCode: response === null || response === void 0 ? void 0 : response.status });
                        _this.errorsQueue.push({
                            id: id || makeHash.makeHash(10),
                            status: response === null || response === void 0 ? void 0 : response.status,
                            url: url,
                            options: options,
                            callback: callback,
                            error: error,
                            response: response,
                            cacheState: cacheState,
                            cacheIndex: cacheIndex,
                        });
                    }
                    else {
                        throw error;
                    }
                })
                    .catch(function (error) {
                    _this.$logger.p('call').error(error);
                    return callback(errors_formatError.formatError(error, true, response || {}), null);
                });
                return [2 /*return*/];
            });
        });
    };
    FetchAMS.prototype.retry = function () {
        var _this = this;
        if (thirdLocation.thirdLocation.isEnabled()) {
            thirdLocation.thirdLocation.loadConf().then(function () {
                thirdLocation.thirdLocation.healthCheck(true).then(function () {
                    _this.connectionStatus = 'stable';
                    var priorityIndex = _this.errorsQueue._queue.findIndex(function (task) { return task.actionStatus === 'freeze'; });
                    _this.errorsQueue.handleAll = true;
                    var nextTask = null;
                    if (priorityIndex !== -1) {
                        nextTask = _this.errorsQueue._queue.splice(priorityIndex, 1)[0];
                    }
                    else {
                        nextTask = _this.errorsQueue._queue.shift();
                    }
                    _this.handleQueue(nextTask);
                });
            }).catch(function (e) {
                _this.$logger.p('loadConf').error(e);
            });
        }
    };
    FetchAMS.prototype.cancel = function () {
        if (thirdLocation.thirdLocation.isEnabled()) {
            // remove all priority requests from queue
            this.errorsQueue.handleAll = true;
            thirdLocation.thirdLocation.clearFailedDomains();
            this.errorsQueue._queue = this.errorsQueue._queue.filter(function (task) { return task.actionStatus !== 'freeze'; });
        }
    };
    FetchAMS.prototype.handleQueue = function (task) {
        var _this = this;
        if (secondLocation.secondLocation.isEnabled()) {
            if (this.connectionStatus === 'stable') {
                var urlInst = new URL(task.url);
                urlInst.host = secondLocation.secondLocation.getBackDomain();
                this.call(urlInst.toString(), task.options, task.callback, task.cacheIndex, task.cacheState, task.id);
            }
            else {
                this.errorsQueue.activeTask = task;
                var nextAction = secondLocation.secondLocation.onBackendFailed(secondLocation.secondLocation.getBackDomain(), task.status, task.cacheState);
                this.$logger.p('2nd/handleQueue').log({
                    len: this.errorsQueue._queue.length,
                    task: task,
                    nextAction: nextAction,
                    connection: this.connectionStatus
                });
                if (nextAction === true) {
                    var urlInst = new URL(task.url);
                    urlInst.host = secondLocation.secondLocation.getBackDomain();
                    this.call(urlInst.toString(), task.options, task.callback, task.cacheIndex, task.cacheState, task.id);
                }
                else if (nextAction === null && task.cacheIndex && localCache.localCache.get(task.cacheIndex, false, true)) {
                    var fromCache = localCache.localCache.get(task.cacheIndex, false, true);
                    fromCache.cached = true;
                    task.callback(null, fromCache);
                }
                else if (isNumber__default["default"](nextAction)) {
                    nextAction = nextAction;
                    setTimeout(function () {
                        _this.call(task.url, task.options, task.callback, task.cacheIndex, task.cacheState, task.id);
                    }, nextAction * 1000);
                }
                else {
                    this.errorsQueue.activeTask = null;
                    throw task.error;
                }
            }
        }
        else if (thirdLocation.thirdLocation.isEnabled()) {
            if (this.connectionStatus === 'stable') {
                this.call(thirdLocation.thirdLocation.formatLink(task.url).toString(), task.options, task.callback, null, null, task.id);
            }
            else {
                this.errorsQueue.activeTask = task;
                var nextAction = thirdLocation.thirdLocation.onBackendFailed(thirdLocation.thirdLocation.get('activeDomain'), task.status, null, true, task.url);
                task.actionStatus = nextAction;
                this.$logger.p('3nd/handleQueue').log({
                    len: this.errorsQueue._queue.length,
                    task: task,
                    nextAction: nextAction,
                    connection: this.connectionStatus
                });
                if (nextAction === true) {
                    thirdLocation.thirdLocation.healthCheck(true).then(function () {
                        _this.call(thirdLocation.thirdLocation.formatLink(task.url).toString(), task.options, task.callback, null, null, task.id);
                    });
                }
                else if (isNumber__default["default"](nextAction)) {
                    nextAction = nextAction;
                    setTimeout(function () {
                        _this.call(thirdLocation.thirdLocation.formatLink(task.url).toString(), task.options, task.callback, null, null, task.id);
                    }, nextAction * 1000);
                }
                else if (nextAction === false) { // not found domains any more, reload conf
                    setTimeout(function () {
                        thirdLocation.thirdLocation.loadConf().then(function () {
                            thirdLocation.thirdLocation.healthCheck(true).then(function () {
                                _this.call(thirdLocation.thirdLocation.formatLink(task.url)
                                    .toString(), task.options, task.callback, null, null, task.id);
                            });
                        }).catch(function (error) {
                            task.callback(errors_formatError.formatError(error, true), null);
                        });
                    }, 2000);
                }
                else if (nextAction === 'freeze') {
                    this.errorsQueue.activeTask = null;
                    this.errorsQueue.handleAll = false;
                    this.errorsQueue.push(task, false);
                }
                else {
                    task.callback(errors_formatError.formatError(task.error, true, task.response || {}), null);
                }
            }
        }
    };
    return FetchAMS;
}());
var fetchAMS = new FetchAMS();

exports.FetchAMS = FetchAMS;
exports.fetchAMS = fetchAMS;
